export const endpoints = {
  auth: {
    loginRedirect: 'auth/microsoft/redirect?surface=app',
    exchangeCode: 'auth/exchange-code',
    refresh: 'auth/refresh',
    logout: 'auth/logout',
  },
  api: {
    me: {
      show: 'app/me',
    },
    users: {
      index: 'app/users',
      show: (id: string) => `app/users/${id}`,
      updateMe: 'app/users/me',
      create: 'app/users',
      update: (id: string) => `app/users/${id}`,
      removeSeat: (id: string) => `app/users/remove-seat/${id}`,
    },
    roles: {
      index: 'app/roles',
      show: (id: string) => `app/roles/${id}`,
      checkName: 'app/roles/check-name',
      store: 'app/roles',
      update: (id: string) => `app/roles/${id}`,
      delete: (id: string) => `app/roles/${id}`,
      permissions: 'app/roles/permissions',
    },
    billing: {
      overview: 'app/billing/overview',
      estimate: 'app/billing/estimate',
      plans: 'app/billing/plans',
      previewPlan: 'app/billing/plans/preview',
      updatePlan: 'app/billing/plans',
      cancel: 'app/billing/cancel',
      resume: 'app/billing/resume',
      paymentMethodSession: 'app/billing/payment-method/session',
      contact: 'app/billing/contact',
      invoices: 'app/billing/invoices',
      retryPayment: 'app/billing/payments/retry',
    },
    licences: {
      index: 'app/licences',
      buy: 'app/licences',
      cancel: 'app/licences/cancel',
      assign: (id: string) => `app/licences/${id}/assign`,
      release: (id: string) => `app/licences/${id}/release`,
      resume: (id: string) => `app/licences/${id}/resume`,
    },
    requestAccess: {
      status: 'app/request-access',
      send: 'app/request-access',
    },
    intune: {
      users: {
        index: 'app/intune/users',
        show: (id: string) => `app/intune/users/${id}`,
        devices: (id: string) => `app/intune/users/${id}/devices`,
        licenses: (id: string) => `app/intune/users/${id}/licenses`,
        resetPassword: (id: string) => `app/intune/users/${id}/reset-password`,
      },
      autopilotDevices: {
        index: 'app/intune/autopilot-devices',
        import: 'app/intune/autopilot-devices/import',
        importHistory: 'app/intune/autopilot-devices/import/history',
        delete: (id: string) => `app/intune/autopilot-devices/${id}`,
      },
      devices: {
        index: 'app/intune/devices',
        next: (id: string) => `app/intune/devices/next/${id}`,
        show: (id: string) => `app/intune/devices/${id}`,
        wipe: (id: string) => `app/intune/devices/${id}/wipe`,
        freshStart: (id: string) => `app/intune/devices/${id}/fresh-start`,
        retrieveBitlocker: (id: string) => `app/intune/devices/${id}/retrieve-bitlocker`,
        autopilotReset: (id: string) => `app/intune/devices/${id}/autopilot-reset`,
        rotateLocalCredentials: (id: string) => `app/intune/devices/${id}/rotate-local-admin-password`,
      },
      next: {
        get: 'app/intune/next',
      },
      search: {
        index: (search: string) => `app/intune/search/${search}`,
      }
    },
    reports: {
      anomalies: 'app/reports/anomalies',
      entraAdminRoles: 'app/reports/entra-admin-roles',
      m365LicenseAssignment: 'app/reports/m365-license-assignment',
    },
  },
};
